<script lang="ts" setup>
import MateGallery from "@/components/mobile/media/MateGallery.vue";
import { useRoute } from "vue-router";
import { computed, onMounted, ref } from "vue";
import { useMate } from "@/stores/mate";
import { useStorageSize } from "@/use/common";
import { useGlobalUser } from "@/stores/globalUser";

const mateId = ref<number | undefined>(undefined);
const route = useRoute();
const mateStore = useMate();
const userStore = useGlobalUser();

// 存储使用率计算
const storageUsagePercentage = computed(() => {
  if (!userStore.user.storageUsage.totalSize) return 0;
  return Math.min(
    (userStore.user.storageUsage.usedSize /
      userStore.user.storageUsage.totalSize) *
      100,
    100
  );
});

const storageProgressColor = computed(() => {
  const percentage = storageUsagePercentage.value;
  if (percentage >= 90) return "bg-error";
  if (percentage >= 75) return "bg-warning";
  return "bg-success";
});

onMounted(() => {
  if (route.query.mateUuid) {
    mateId.value = mateStore.mateMap.get(route.query.mateUuid as string)!.id;
  }
});
</script>

<template>
  <div class="w-full h-full grid grid-rows-[auto_auto_1fr] overflow-hidden">
    <ThreadsNav show-back :show-center="false" />

    <div
      class="flex p-4 mx-2 mb-2 gap-4 items-center cursor-pointer bg-base-200 rounded-xl"
    >
      <!-- 存储空间使用情况 -->
      <div class="flex flex-col gap-2 w-full">
        <div class="flex justify-between items-center text-xs">
          <span class="text-base-content/70">稿件空间使用情况</span>
          <span class="text-base-content/90 font-medium">
            {{ useStorageSize(userStore.user.storageUsage.usedSize) }}/{{
              useStorageSize(userStore.user.storageUsage.totalSize)
            }}
          </span>
        </div>

        <!-- 进度条 -->
        <div class="w-full bg-base-300 rounded-full h-2 overflow-hidden">
          <div
            :class="[
              'h-full rounded-full transition-all duration-300 ease-out',
              storageProgressColor,
            ]"
            :style="{ width: `${storageUsagePercentage}%` }"
          />
        </div>

        <!-- 百分比显示 -->
        <div class="flex justify-between items-center text-xs">
          <span class="text-base-content/50">
            {{ Math.round(storageUsagePercentage) }}% 已使用
          </span>
          <span
            v-if="storageUsagePercentage >= 75"
            :class="[
              'text-xs',
              storageUsagePercentage >= 99 ? 'text-error' : 'text-warning',
            ]"
          >
            {{ storageUsagePercentage >= 99 ? "存储空间已满" : "空间不足" }}
          </span>
        </div>
      </div>
    </div>
    <MateGallery
      class="overflow-hidden h-full"
      enable-mate-switch
      enable-upload
      v-model:mate-id="mateId"
    />
  </div>
</template>
